import { MeetingModel } from '../../models/meetingModel/MeetingModel';
import { agendaResponse } from '../../models/agendaModel/agendaResponse';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AgendaService {
  private base = environment.urlServerApi;
  constructor(private _http: HttpClient) {
  }
  getAgendaItem(IdMeet) : Observable<agendaResponse> {
    return this._http.get<agendaResponse>(`${this.base}agenda?idMeet=${IdMeet}`);
  }
 
}
